'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _httpStatusCodes = require('http-status-codes');

var _httpStatusCodes2 = _interopRequireDefault(_httpStatusCodes);

var _delay = require('../lib/delay');

var _delay2 = _interopRequireDefault(_delay);

var _httpConstants = require('./httpConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Utils
var isServerError = function isServerError(err) {
    return err.response && err.response.status >= _httpStatusCodes2.default.INTERNAL_SERVER_ERROR;
};

// Constants
// Lib

var isTimeoutError = function isTimeoutError(err) {
    return err.code === _httpConstants.ERROR_CODES.CONNECTION_ABORTED || err.code === _httpConstants.ERROR_CODES.CONNECTION_RESET;
};
var isRetriableError = function isRetriableError(err) {
    return isServerError(err) || isTimeoutError(err);
};
var hasRetryConfig = function hasRetryConfig(err) {
    return err.config && err.config.retry && err.config._retryCount !== err.config.retry;
};

var POWER = 3;
// milliseconds
var INITIAL_DELAY = 100;

// Server error delay will have an exponential back off
// 100ms, 800ms, 2.7s, 6.4s...
var getServerErrorDelay = function getServerErrorDelay(err) {
    return INITIAL_DELAY * Math.pow(err.config._retryCount, POWER);
};
// Timeout error delay will multiply the timeout by the number of retries in case the server is overloaded
var getTimeoutErrorDelay = function getTimeoutErrorDelay(err) {
    return err.config.timeout * err.config._retryCount;
};
var getDelay = function getDelay(err) {
    return isTimeoutError(err) ? getTimeoutErrorDelay(err) : getServerErrorDelay(err);
};

exports.default = function (axiosInstance, errorCb) {
    return function (err) {
        // Don't retry if not configured to or it's not a retriable error
        if (!hasRetryConfig(err) || !isRetriableError(err)) throw err;

        err.config._retryCount = err.config._retryCount || 0;
        errorCb && errorCb(err);

        err.config._retryCount = err.config._retryCount + 1;
        var delayTime = getDelay(err);

        return (0, _delay2.default)(delayTime).then(function () {
            return axiosInstance(err.config);
        });
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/common/utils/http/responseRetryInterceptor.js
// module id = 2291
// module chunks = 0